import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
import { SideBar } from '../Common/SideBar';
class SellerBuyerDirectMessage extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        this.state = {

        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <SideBar />
                                </div>
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="mt-5 mb-3 input_name big_font guide_text">
                                                Direct Message Details
                                            </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                        <Link to={'/seller-buyer-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                                            Return to Direct Message List
                                        </Link>
                                    </div>
                                    <div className="message_details_box m-2">
                                        <div className="m-2">
                                            <div className="row">
                                                <div className="col-md-2 mini_pad">
                                                    <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="80%" /><br />
                                                    {/* <div className="special_padd mt-4 pr-2"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                </div>
                                                <div className="m-2">
                                                    <div className="user_message">
                                                        MR.X
                                                    </div>
                                                    <div className="message_login">
                                                        Last Login:2 Days Ago
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="message_to_buy">
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <div className="message_login m-2">
                                                        There is a proposal of a quote and customization
                                                    </div>
                                                </div>
                                                <div className="col-md-4 text-right pt-1">
                                                    <button className="btn btn-sm btn-success">
                                                        Buy/Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-2">
                                            <div className="row">
                                                <div className="col-md-2 mini_pad">
                                                    <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                    {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                </div>
                                                <div className="col-md-7 ">
                                                    <div className="message_name_text">
                                                        <span><b>Mr.Z</b></span><br />
                                                    </div>
                                                    <div className="product_description">
                                                        A logo is identity uniqueness, and it needs to be recognized visually.
                                                    </div>
                                                    <div className="message_open_time">
                                                        Opened 2019-06-17
                                                    </div>
                                                </div>
                                                <div className="col-md-3 message_time">
                                                    2019-06-17 23:12:14
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                        <div className="m-2">
                                            <div className="row">
                                                <div className="col-md-2 mini_pad">
                                                    <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                    {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                </div>
                                                <div className="col-md-7 ">
                                                    <div className="message_name_text">
                                                        <span><b>Mr.X</b></span><br />
                                                    </div>
                                                    <div className="product_description">
                                                        A logo is identity uniqueness, and it needs to be recognized visually.
                                                    </div>
                                                    <div className="message_open_time">
                                                        Opened 2019-06-18
                                                    </div>
                                                </div>
                                                <div className="col-md-3 message_time">
                                                    2019-06-18 13:12:14
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                        <div className="m-2">
                                            <div className="row">
                                                <div className="col-md-2 mini_pad">
                                                    <img src={require("../../assets/images/image1.jpeg")} className=" rounded-circle" alt="" width="100%" height="70%" /><br />
                                                    {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                </div>
                                                <div className="col-md-10 ">
                                                    <div className="row row_edit" >
                                                        <div className="col-md-3 message text-center">
                                                            <span className=""><b>message</b></span><br />
                                                        </div>
                                                        <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                        </div>
                                                    </div>
                                                    <div className="message_form">
                                                        <textarea className="message_textarea m-2"></textarea>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="text-center p-3 " >
                                            <button type="submit" className="btn btn-lg btn-success " >
                                                <span className="fa fa-check"></span>
                                                 Send Message
                                            </button>
                                        </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { SellerBuyerDirectMessage }